import { SpendTypeEnum } from 'components/Classification';

export const ROOT_ROUTE = '/classification';

export const CONFIG = [
  {
    path: `${ROOT_ROUTE}/${SpendTypeEnum.THIRD_PARTY}`,
    name: SpendTypeEnum.THIRD_PARTY,
  },
  {
    path: `${ROOT_ROUTE}/${SpendTypeEnum.PERSONNEL}`,
    name: SpendTypeEnum.PERSONNEL,
  },
];
